var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed",attrs:{"href":"https://www.iubenda.com/privacy-policy/84994680","title":"Privacy Policy"}},[_vm._v("Privacy Policy")])
}
var staticRenderFns = []

export { render, staticRenderFns }